import Vue from 'vue'
import App from './App.vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/pro-solid-svg-icons'
import { far } from '@fortawesome/pro-regular-svg-icons'
import { fal } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import vuetify from './plugins/vuetify';
import i18n from '@/plugins/i18n'
import store from '@/store'
import router from '@/router'

export const eventBus = new Vue(); // creating an event bus.

require('@/css/style.scss')

Vue.config.productionTip = false

Vue.config.devtools = true;

library.add(fas)
library.add(far)
library.add(fal)
Vue.component('fa', FontAwesomeIcon)

new Vue({
  vuetify,
  i18n,
  store,
  router,
  eventBus,
  render: h => h(App)
}).$mount('#app')
